import React from 'react';
import { cn } from '@/lib/utils';

interface SidebarLayoutProps {
  children: React.ReactNode;
  sidebar: React.ReactNode;
  contentClassName?: string;
  sidebarClassName?: string;
  reversed?: boolean;
  hasAccordion?: boolean;
}

/**
 * A consistent layout component with main content and sidebar
 * Uses a 7:5 ratio for content to sidebar on large screens
 */
const SidebarLayout: React.FC<SidebarLayoutProps> = ({
  children,
  sidebar,
  contentClassName,
  sidebarClassName,
  reversed = false,
  hasAccordion = false,
}) => {
  return (
    <div className="flex flex-col lg:flex-row gap-2 md:gap-6">
      {/* Sidebar - Always first on mobile */}
      <div 
        className={cn(
          "order-first lg:order-none lg:flex-shrink-0 transition-all duration-300 ease-in-out",
          "lg:w-[400px]", // Fixed width since no synchronization needed
          reversed ? "lg:order-first" : "",
          sidebarClassName
        )}
      >
        <div className="h-full">
            {sidebar}
        </div>
      </div>
      
      {/* Main Content - Always second on mobile */}
      <div 
        className={cn(
          "order-last lg:order-none lg:flex-grow transition-all duration-300 ease-in-out",
          reversed ? "" : "lg:order-first",
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default SidebarLayout;
